import gql from 'graphql-tag';

export const CreateIncidentIssue = gql`
  mutation CreateIncidentIssueBulk($input: CreateIncidentIssueBulkInput!) {
    createIncidentIssueBulk(input: $input) {
      output {
        error
        output {
          issue {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            description
            dispatcherId
            incidentDatetime
            outboundDatetime
            samsaraCameraWorking
            driverId
            vehicleId
            crewInvolved
            tripId
            outboundFlightNumber
            medicalInjuries
            medicalNeeded
            propertyDamage
            incidentOccurance
            incidentOccuranceOther
            managerId
            crewInfo
            recoveryInfo
            medicalAttentionType
            propertyDamageDescription
            incidentWitnesses
            station
            deletedAt
            deletedBy
            traceId
            outboundFlightName
          }
          document {
            document {
              id
              createdAt
              createdBy
              updatedAt
              updatedBy
              issueId
              filename
              fileLocation
              contentType
              fileSize
              md5
              deletedAt
              deletedBy
              traceId
            }
            presignedUrl
          }
        }
      }
    }
  }
`;
